import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import appConfig from "./Config/config"
import App from "./App";
import "semantic-ui-css/semantic.min.css";
import "./index.css";
import { Provider } from "react-redux";
import store from "./Store/store";

// Suppress benign ResizeObserver loop errors that trigger webpack error overlay on zoom / resize
window.addEventListener("error", (e) => {
	if (
		e.message &&
		(e.message.includes("ResizeObserver loop completed with undelivered notifications") ||
			e.message.includes("ResizeObserver loop limit exceeded"))
	) {
		e.stopImmediatePropagation();
		e.preventDefault();
	}
});

window.addEventListener("unhandledrejection", (e) => {
	if (
		e.reason &&
		e.reason.message &&
		(e.reason.message.includes("ResizeObserver loop completed with undelivered notifications") ||
			e.reason.message.includes("ResizeObserver loop limit exceeded"))
	) {
		e.stopImmediatePropagation();
		e.preventDefault();
	}
});

ReactDOM.render(
	<Provider store={store}>
		{/* <GoogleReCaptchaProvider
			// reCaptchaKey={"6Lde-yQpAAAAAG9r4LOIDb75g5-fjU5B_13k-RVQ"}
			// reCaptchaKey={process.env.REACT_APP_GOOGLE_RECAPTCHA_V3_CLIENT_KEY || appConfig.GOOGLE_RECAPTCHA_V3_CLIENT_KEY || "6LegTDYnAAAAAN9mLF-5AHNJ8EELSJf443tQaro1"}
			reCaptchaKey={process.env.REACT_APP_GOOGLE_RECAPTCHA_V3_CLIENT_KEY || "6LegTDYnAAAAAN9mLF-5AHNJ8EELSJf443tQaro1"}
			useEnterprise={true}
			scriptProps={{
				async: false, // optional, default to false,
				defer: false, // optional, default to false
				appendTo: 'head', // optional, default to "head", can be "head" or "body",
				nonce: undefined // optional, default undefined
			}}
		> */}
		<BrowserRouter>
			<App />
		</BrowserRouter>
		{/* </GoogleReCaptchaProvider> */}
	</Provider>,
	document.getElementById("root")
);
